import { createSlice } from '@reduxjs/toolkit'
import baseReducers from 'apiV2/store/base/reducers'
import baseInitialState from 'apiV2/store/base/initialState'
import { indexTaskListTemplatesAPI } from './asyncActions'

export const taskListTemplateSlice = createSlice({
  name: 'task_list_templates',
  initialState: baseInitialState,
  reducers: baseReducers,
  extraReducers: {
    [indexTaskListTemplatesAPI.pending](state) {
      state.uiFlags.isFetching = true
    },
    [indexTaskListTemplatesAPI.fulfilled](state, action) {
      state.stagedRecord = action.payload.data
      state.uiFlags.isFetching = false
    },
    [indexTaskListTemplatesAPI.rejected](state) {
      state.uiFlags.isFetching = false
    },
  },
})

export default taskListTemplateSlice.reducer
